export default "__VITE_ASSET__D$xVTj$I__"